import { render, staticRenderFns } from "./BodyScripts.vue?vue&type=template&id=10a39774&scoped=true"
import script from "./BodyScripts.vue?vue&type=script&lang=js"
export * from "./BodyScripts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a39774",
  null
  
)

export default component.exports